import { supabaseProjectId } from "./constants";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getToken = () => {
  const storageKey = `sb-${supabaseProjectId}-auth-token`;
  const sessionDataString = localStorage.getItem(storageKey);
  const sessionData = JSON.parse(sessionDataString || "null");
  const token = sessionData?.access_token;

  return token;
};

export const scrapeSite = async (url: string) => {
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: getToken(),
    },
    body: JSON.stringify({ url }),
  };

  const siteData = await fetch(
    (!process.env.NODE_ENV || process.env.NODE_ENV === "development") &&
      BASE_URL
      ? `${BASE_URL}/scrape`
      : `${window.location.origin}/api/scrape`,
    options
  );
  console.log(siteData);
  return siteData;
};
